"use strict";
/* globals module */
/**
 * @module calendarEventTypeBatchClient
 * @description  CalendarEventTypeBatchClient provides an easy way to consume CalendarEventTypeBatch REST API end-points. In order to obtain needed routes `calendarEventTypeBatchClient` uses `calendarEventTypeBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var inversify_1 = require("inversify");
;
var httpApi_1 = require("../../../../httpApi");
var __1 = require("../../");
var CalendarEventTypeBatchClient = /** @class */ (function () {
    function CalendarEventTypeBatchClient(calendarEventTypeBatchRoute, apiClient) {
        this.calendarEventTypeBatchRoute = calendarEventTypeBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarEventTypeBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarEventTypeBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create CalendarEventTypes action has been performed; this action creates new CalendarEventType resources.
     * @method
     * @param data CalendarEventType objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create CalendarEventTypes action has been performed.
     * @example calendarEventTypeBatchClient.create([{
                    abrv: '<abrv>',
                    json: '<json>',
                    name: '<name>'
                }])
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventTypeBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventTypes action has been performed; this action updates CalendarEventType resources.
     * @method
     * @param data CalendarEventType objects used to update specified CalendarEventType resources.
     * @returns A promise that is resolved once the update CalendarEventTypes action has been performed.
     * @example calendarEventTypes are resources previously fetched using get action.
                calendarEventTypeBatchClient.update(calendarEventTypes)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
    */
    CalendarEventTypeBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove CalendarEventType resources from the system if successfully completed.
     * @method
     * @param data CalendarEventType Ids which uniquely identify CalendarEventType resources to be deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example calendarEventTypeIds are identifiers which uniquely identify CalendarEventType resources.
                calendarEventTypeBatchClient.remove(calendarEventTypeIds)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventTypeBatchClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(), undefined, this.routeDefinition.deleteParams(data));
    };
    var _a, _b;
    CalendarEventTypeBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarEventTypeBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarEventTypeBatchRoute !== "undefined" && __1.CalendarEventTypeBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CalendarEventTypeBatchClient);
    return CalendarEventTypeBatchClient;
}());
exports.CalendarEventTypeBatchClient = CalendarEventTypeBatchClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 
